const locale = {
    placeholder: 'Vybrať čas',
    rangePlaceholder: ['Čas začiatku', 'Čas konca'],
};
export default locale;
